import { render, staticRenderFns } from "./EK-table-colabse-child.vue?vue&type=template&id=a2f1cc60"
import script from "./EK-table-colabse-child.vue?vue&type=script&lang=js"
export * from "./EK-table-colabse-child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports